/**
 * Reusable selector functions that may not be specific to one reducer.
 */
import { isConfigFlagEnabled } from '../config';
import { selectIsMyPlayerIn } from './reducers/pokerReducer';
export function selectIsTourneyRoom(state) {
    if (state.scene.roomSceneType === 'mttStaging') {
        return true;
    }
    if (state.scene.roomSceneType === 'poker' && !!state.poker.tourneyProperties) {
        return true;
    }
    return false;
}
function canAffordSideBet(state) {
    if (state.poker.sideBetCost === undefined) {
        // side bet cost in room not yet initialized
        return false;
    }
    if (state.selfData.numJacks === undefined) {
        // player's jacks not yet initialized
        return false;
    }
    return state.selfData.numJacks >= state.poker.sideBetCost;
}
export function selectSideBettingState(state) {
    if (!isConfigFlagEnabled('sideBets')) {
        return 'off';
    }
    if (state.scene.roomSceneType !== 'poker') {
        // don't show side bet button in player info panel outside of poker scene
        return 'off';
    }
    if (!state.selfData.isSideBettingSettingEnabled) {
        return 'off';
    }
    if (!canAffordSideBet(state)) {
        return 'disabled';
    }
    if (state.poker.turnState !== 'bet') {
        return 'disabled';
    }
    if (state.sideBets.areMySideBetControlsDisabled) {
        return 'disabled';
    }
    if (Object.keys(state.poker.revealedHands).length) {
        // disable if in an all-in showdown where hand is auto-dealing
        return 'disabled';
    }
    const isIn = selectIsMyPlayerIn(state);
    return isIn ? 'disabled' : 'available';
}
